import React from 'react';
import embeddedAppUtils from '../../utils/embeddedAppUtils';
import { Loading } from '@shopify/polaris';

export const LoadingBar: React.FC = (props) => {
    return <>{embeddedAppUtils.isAppEmbedded() ? <Loading /> : <Loading />}</>;
};
